'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _viewprt = require('viewprt');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var viewportElements = context.getElements('.' + context.className);

  viewportElements.forEach(function (viewportElement) {
    (0, _viewprt.ElementObserver)(viewportElement, {
      onEnter: function onEnter() {
        viewportElement.classList.add(context.className + '-active');
        viewportElement.classList.remove('' + context.className);
      }
    });
  });
}